import { useMutation } from "react-query";
import downloadExternalAccountConfigCSV from "../services/downloadExternalAccountConfigCSV";

function useDownloadExternalAccountConfig() {
  return useMutation(["download-external-account-config-csv"], downloadExternalAccountConfigCSV);
}

export default useDownloadExternalAccountConfig;
